import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

export interface Toast {
  id: string;
  mainTitle: string;
  subTitle: string;
  color: string;
  status: 'success' | 'error';
  view?: string | null;
  duration?: number; // ms
}

@Injectable({ providedIn: 'root' })
export class ToasterService {
  private readonly toastsSubject = new BehaviorSubject<Toast[]>([]);
  toasts$ = this.toastsSubject.asObservable();

  showToast(toast: Omit<Toast, 'id'>) {
    const id = Math.random().toString(36).slice(2,11);
    const newToast: Toast = { id, ...toast };
    this.toastsSubject.next([...this.toastsSubject.value, newToast]);
    if (toast.duration !== 0) {
      setTimeout(() => this.dismissToast(id), toast.duration ?? 4000);
    }
  }

  dismissToast(id: string) {
    this.toastsSubject.next(this.toastsSubject.value.filter(t => t.id !== id));
  }

  clearAll() {
    this.toastsSubject.next([]);
  }

  showApiResponseToast(response: any) {
    const ERROR_CODE_MAP: Record<string, { mainTitle: string; status: 'success' | 'error'; color: string }> = {
      '0000': { mainTitle: 'Success', status: 'success', color: '#B6F2C8' },
      '1000': { mainTitle: 'Input Validation Error', status: 'error', color: '#FDECEC' },
      '1001': { mainTitle: 'Something went wrong', status: 'error', color: '#FDECEC' },
      '1010': { mainTitle: 'Missing Required Role', status: 'error', color: '#FDECEC' },
      '1011': { mainTitle: 'Missing Required Permission', status: 'error', color: '#FDECEC' },
      '1111': { mainTitle: 'Maximum Sessions Reached', status: 'error', color: '#FDECEC' },
      '1112': { mainTitle: 'User Not Found', status: 'error', color: '#FDECEC' },
      '1113': { mainTitle: 'Invalid Credentials', status: 'error', color: '#FDECEC' },
      '1114': { mainTitle: 'Login Failed', status: 'error', color: '#FDECEC' },
      '1115': { mainTitle: 'User Not Active', status: 'error', color: '#FDECEC' },
      '1116': { mainTitle: 'Organization Not Found', status: 'error', color: '#FDECEC' },
      '1005': { mainTitle: 'Invalid OTP', status: 'error', color: '#FDECEC' },
      '1009': { mainTitle: 'Expired OTP', status: 'error', color: '#FDECEC' },
    };
    const code = response?.error_status?.error_code || '1001';
    const config = ERROR_CODE_MAP[code] || ERROR_CODE_MAP['1001'];
    this.showToast({
      mainTitle: config.mainTitle,
      subTitle: response?.message || 'Something went wrong',
      color: config.color,
      status: config.status,
      duration: 4000
    });
  }
} 